import { useState } from "react";

const OPTIONS = [0, 15, 20, 25];

export const TipPicker = ({ base, tip, setTip, testid = "tip" }) => {
  const [mode, setMode] = useState("0");
  const [custom, setCustom] = useState("");
  const pick = (p) => {
    setMode(String(p));
    setTip(Math.round(base * p) / 100);
  };
  return (
    <div className="space-y-2" data-testid={`${testid}-picker`}>
      <p className="text-xs uppercase tracking-[0.25em] text-gray-500">Add a tip for the crew <span className="normal-case tracking-normal">(% of the ${Number(base).toFixed(0)} full job total)</span></p>
      <div className="grid grid-cols-5 gap-2">
        {OPTIONS.map((p) => (
          <button key={p} type="button" onClick={() => pick(p)} data-testid={`${testid}-${p}`}
            className={`h-11 rounded-xl text-sm border transition-colors ${mode === String(p) ? "border-sky-400 bg-sky-500/15 text-white" : "border-white/10 text-gray-400 hover:text-white"}`}>
            {p === 0 ? "No tip" : `${p}%`}
          </button>
        ))}
        <button type="button" onClick={() => { setMode("custom"); setTip(Number(custom) || 0); }} data-testid={`${testid}-custom`}
          className={`h-11 rounded-xl text-sm border transition-colors ${mode === "custom" ? "border-sky-400 bg-sky-500/15 text-white" : "border-white/10 text-gray-400 hover:text-white"}`}>
          Custom
        </button>
      </div>
      {mode === "custom" && (
        <input type="number" min={0} step="1" placeholder="Tip amount ($)" value={custom} data-testid={`${testid}-custom-input`}
          onChange={(e) => { setCustom(e.target.value); setTip(Math.max(0, Number(e.target.value) || 0)); }}
          className="w-full h-11 rounded-xl px-3 bg-black/40 border border-white/10 text-white text-sm outline-none focus:border-sky-400" />
      )}
      {tip > 0 && <p className="text-xs text-sky-300" data-testid={`${testid}-amount`}>Tip ${tip.toFixed(2)}{mode !== "custom" && mode !== "0" ? ` (${mode}% of $${Number(base).toFixed(0)})` : ""}, added to today's charge. Thank you!</p>}
    </div>
  );
};

export default TipPicker;
